<app-listagem-obras
    title="Obras ainda não vistas"
    [subtitle]="'(' + totalItems + ')'"
    [descriptionSubtitle]="'Obras atribuídas que ainda não foram acessadas por você ou pela equipe responsável.'"
    [data]="obras"
    [pageSize]="pageSize"
    [totalItems]="totalItems"
    [page]="page"
    (pageChange)="onPageChange($event)"
    (sortChange)="ordenarPor($event.column)"
    (selectionChange)="onSelectionChange($event)"
    (pageSizeChange)="onPageSizeChange($event)"
    (tiposSelecionadosChange)="onTiposObraSelecionadosChange($event)"
    (abrirFichaObra)="abrirDetalhesObra($event)"
    (downloadPdf)="downloadPDFFicha()"
    (imprimir)="impressaoFicha()"
    (abrirEmpresa)="onAbrirEmpresa($event)" 
    [loading]="loadingWorks"
    [selectedRows]="selectedRows"
    [searchType]="searchType"
    [searchTerm]="searchTerm"
    (searchTypeChange)="onSearchTypeChange($event)"
    (searchTermChange)="onSearchTermChange($event)"
    (searchEnter)="onSearchEnter()"
    [updateInterval]="updateInterval"
    (updateIntervalChange)="onUpdateIntervalChange($event)"
  ></app-listagem-obras>


<app-common-loader *ngIf="loadingWorks"></app-common-loader>
